import { render } from "./TaskListHeader.vue?vue&type=template&id=c7a173ba"
import script from "./TaskListHeader.vue?vue&type=script&lang=js"
export * from "./TaskListHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/guangdong.chen/development/ATech/frontend/app/gantt-elastic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__